"use client";
import Image from "next/image";
import { useState } from "react";

const ProductImage = ({ product }) => {
  const [imgSrc, setImgSrc] = useState(product?.images?.[0] || "/placeholder.jpg");

  return (
    <div className="relative w-full h-full">
      <Image
        src={imgSrc}
        alt={product?.title || "Product Image"}
        fill
        sizes="(max-width: 768px) 100vw, 400px"
        className="object-contain"
        onError={() => {
          setImgSrc("/placeholder.jpg");
        }}
        priority={false}
      />
    </div>
  );
};

export default ProductImage;